import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { FamilyMemberMemberDuplicationCheckDTO } from '@/api/DTO/member-management/memberDuplication';
import MemberStatusChip from '@/common/components/MemberStatusChip';
import {
	MatchedNameCell,
	MatchedText,
	ViewRecordCell,
} from '@/common/components/member-duplication/DuplicationCells';

/** CHA-005 §四: columns of the member records that may be the family member applicant. */
export const useMemberLinkColumns =
	(): GridColDef<FamilyMemberMemberDuplicationCheckDTO>[] => {
		const { t } = useTranslation();
		return [
			{
				field: 'fileNo',
				headerName: t('member.fileNo'),
				flex: 16,
				renderCell: (params) => params.row.fileNo || '-',
			},
			{
				field: 'nameEn',
				headerName: t('family.name'),
				flex: 20,
				renderCell: (params) => (
					<MatchedNameCell
						nameEn={params.row.nameEn}
						nameZh={params.row.nameZh}
						matchedFields={params.row.matchedFields}
					/>
				),
			},
			{
				field: 'phone',
				headerName: t('family.mobilePhone'),
				flex: 14,
				renderCell: (params) => (
					<MatchedText
						value={params.row.phone}
						field='PHONE'
						matchedFields={params.row.matchedFields}
					/>
				),
			},
			{
				field: 'hkid',
				headerName: t('member.HKID'),
				flex: 14,
				renderCell: (params) => (
					<MatchedText
						value={params.row.hkid}
						field='HKID'
						matchedFields={params.row.matchedFields}
					/>
				),
			},
			{
				field: 'status',
				headerName: t('member.status'),
				flex: 18,
				renderCell: (params) =>
					params.row.statusDesc ? (
						<MemberStatusChip
							status={params.row.status ?? undefined}
							label={params.row.statusDesc}
						/>
					) : (
						'-'
					),
			},
			{
				field: 'view',
				headerName: '',
				width: 68,
				renderCell: (params) => (
					<ViewRecordCell
						id={params.row.id}
						status={params.row.status}
						canSeen={params.row.canSeen}
					/>
				),
			},
		];
	};
